// Deprecated alias — use `@/components/DataTable`. Kept so nothing breaks mid-migration.
import React from 'react';import DataTable from '@/components/DataTable';
const TableContainer = (props) => <DataTable columnConfig={false} pagination={false} {...props} />;
export default TableContainer;
